module.exports = require("https");


//////////////////
// WEBPACK FOOTER
// external "https"
// module id = 13
// module chunks = 0